var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup436(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#707070;stroke-linecap:round;stroke-width:3px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_557",
    fill: "none",
    d: "M0 0H55V55H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    transform: "translate(7.885 18.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_18",
    d: "M0 0L0 17.251",
    className: "cls-2",
    transform: "translate(3.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3px",
    d: "M-33.546 1058.724l3.516 3.854 3.517-3.854",
    transform: "translate(33.546 -1044.666)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    d: "M0 0L21.634 0",
    className: "cls-2",
    transform: "translate(24.583 20.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    d: "M0 0L15.624 0",
    className: "cls-2",
    transform: "translate(24.583 27.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_21",
    d: "M0 0L19.23 0",
    className: "cls-2",
    transform: "translate(24.583 34.168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup436);
export default __webpack_public_path__ + "static/media/Group 436.6e077a1b5fb70b2d2b965f49a25c811f.svg";
export { ForwardRef as ReactComponent };